import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_SESSIONS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getChargingSessionListAPI: any = createAsyncThunk(
  "getChargingSessionList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(CHARGING_SESSIONS, {
        headers: commonHead,
        params: params,
      });
      ;
      return { cSessionList: res };
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
